export enum Views {
  ASSET_SUMMARY = 'assetSummary',
  ISSUE = 'issue',
  EVENT = 'event'
}
